import { initialState } from "./state"
export default {
  setFiles: (state, payload) => (state.files = payload),
  resetFiles: state => {
    const init_state = initialState()
    Object.keys(state).forEach(key => {
      state[key] = init_state[key]
    })
  }
}
